module.exports = [["house","Haus"],["apartement","Wohnung"]]


//////////////////
// WEBPACK FOOTER
// ./src/pages/Helpers/Storage/HouseSituation.json
// module id = 221
// module chunks = 0